module.exports = __webpack_public_path__ + "media/images/boat-d9639205bf7c4a9b7b48fa3424611fd4.png";